import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosBaseURL from "../../common/apis/axiosBaseURL";
import { apiVersion } from "../../common/apis/apiVersion";
var jwt = require("jsonwebtoken");

export const AuthAsyncLogin = createAsyncThunk(
  "auth/AuthAsyncLogin",
  async (data) => {
    try {
      const response = await axiosBaseURL.post(
        `/app/${apiVersion.v1}/users/login`,
        data
      );
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }
);

export const AuthAsyncSignup = createAsyncThunk(
  "auth/AuthAsyncSignup",
  async (data) => {
    try {
      const response = await axiosBaseURL.post(
        "/app/" + apiVersion.v1 + "/users/register",
        data
      );
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }
);

export const AuthAsyncOTP = createAsyncThunk(
  "auth/AuthAsyncOTP",
  async (data, apiPath) => {
    try {
      const response = await axiosBaseURL.post(
        `/app/${apiVersion.v1}/users/${apiPath.getState().auth.otpEndPoint}`,
        data
      );
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }
);

export const AuthAsyncResendOTP = createAsyncThunk(
  "auth/AuthAsyncResendOTP",
  async (data) => {
    try {
      const response = await axiosBaseURL.post(
        `/app/${apiVersion.v1}/users/resend`,
        data
      );
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }
);

export const AuthSocialMediaAction = createAsyncThunk(
  "auth/AuthSocialMediaAction",
  async (data) => {
    try {
      const response = await axiosBaseURL.post(
        `/app/${apiVersion.v1}/users/social_login`,
        data
      );
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }
);

export const sendAppLinkAction = createAsyncThunk(
  "auth/sendAppLinkAction",
  async (data) => {
    try {
      const response = await axiosBaseURL.post(
        `/app/${apiVersion.v1}/users/send_app_link`,
        data
      );
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }
);

const initialState = {
  login: {},
  signup: {},
  user: {},
  resend_otp: {},
  loading: "",
  otpEndPoint: "",
  isAuthenticated: false,
  prevPage: "",
  social: {},
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCurrentUser: (state, { payload }) => {
      return { ...state, isAuthenticated: true, user: payload };
    },
    ResetVerifyUser: (state, { payload }) => {
      return { ...state, isAuthenticated: false, user: {} };
    },
    ResetSocialLoginData: (state) => {
      return { ...state, isAuthenticated: false, social: {} };
    },
  },
  extraReducers: {
    [AuthAsyncLogin.pending]: (state) => {
      return { ...state, loading: true };
    },
    [AuthAsyncLogin.fulfilled]: (state, { payload }) => {
      return {
        ...state,
        login: payload,
        otpEndPoint: payload.data.isVerifed === 1 ? "verifyotp" : "verifyphone",
        prevPage: "loading",
        loading: false,
      };
    },
    [AuthAsyncLogin.rejected]: (state) => {
      return { ...state, loading: false };
    },

    [AuthAsyncSignup.pending]: (state) => {
      return { ...state, loading: true };
    },
    [AuthAsyncSignup.fulfilled]: (state, { payload }) => {
      return {
        ...state,
        signup: payload,
        otpEndPoint: "verifyphone",
        loading: false,
      };
    },
    [AuthAsyncSignup.rejected]: (state) => {
      return { ...state, loading: false };
    },

    [AuthAsyncResendOTP.pending]: (state) => {
      return { ...state, loading: true };
    },
    [AuthAsyncResendOTP.fulfilled]: (state, { payload }) => {
      return { ...state, resend_otp: payload, loading: false };
    },
    [AuthAsyncResendOTP.rejected]: (state) => {
      return { ...state, loading: false };
    },

    [AuthAsyncOTP.pending]: (state) => {
      return { ...state, loading: true, isAuthenticated: false };
    },
    [AuthAsyncOTP.fulfilled]: (state, { payload }) => {
      payload.data["timezone"] = "Asia/Kolkata";
      if (payload.status) {
        if (!payload.data.isVerifed) {
          return {
            ...state,
            isAuthenticated: false,
            signup: payload,
            loading: false,
          };
        } else {
          var token = jwt.sign(payload.data, process.env.REACT_APP_JWT_SECRET);
          localStorage.setItem("auth_security", token);
          localStorage.setItem("auth_data", JSON.stringify(payload.data));
          return {
            ...state,
            isAuthenticated: true,
            user: payload,
            loading: false,
          };
        }
      } else {
        return {
          ...state,
          isAuthenticated: false,
          signup: payload,
          loading: false,
        };
      }
    },
    [AuthAsyncOTP.rejected]: (state) => {
      return { ...state, loading: false, isAuthenticated: false };
    },

    [AuthSocialMediaAction.pending]: (state) => {
      return { ...state, loading: true, isAuthenticated: false };
    },
    [AuthSocialMediaAction.fulfilled]: (state, { payload }) => {
      if (payload.status) {
        if (!payload.data.isVerifed) {
          return {
            ...state,
            isAuthenticated: false,
            otpEndPoint: "verifyphone",
            social: payload,
            loading: false,
          };
        } else {
          payload.data["timezone"] = "Europe/Madrid2";
          var token = jwt.sign(payload.data, process.env.REACT_APP_JWT_SECRET);
          localStorage.setItem("auth_security", token);
          localStorage.setItem("auth_data", JSON.stringify(payload.data));
          return {
            ...state,
            isAuthenticated: true,
            user: payload,
            social: payload,
            loading: false,
          };
        }
      } else {
        return {
          ...state,
          isAuthenticated: false,
          otpEndPoint: "verifyphone",
          social: payload,
          loading: false,
        };
      }
    },
    [AuthSocialMediaAction.rejected]: (state) => {
      return { ...state, loading: false, isAuthenticated: false };
    },

    [sendAppLinkAction.pending]: (state) => {
      return { ...state, loading: true, isAuthenticated: false };
    },
    [sendAppLinkAction.fulfilled]: (state, { payload }) => {
      if (payload.status) {
        return { ...state, user: payload, applink: payload, loading: false };
      } else {
        return { ...state, applink: payload, loading: false };
      }
    },
    [sendAppLinkAction.rejected]: (state) => {
      return { ...state, loading: false, isAuthenticated: false };
    },
  },
});
export const { setCurrentUser, ResetVerifyUser, ResetSocialLoginData } =
  authSlice.actions;
export const getLoading = (state) => state.auth;
export const getLoginData = (state) => state.auth.login;
export const getSignupData = (state) => state.auth.signup;
export const getResendOTPData = (state) => state.auth.resend_otp;
export const getOTPData = (state) => state.auth.user;
export const getSocialData = (state) => state.auth.social;

export default authSlice.reducer;
